<template>
  <div>
    <div v-html="text" class="darkgrey text" :style="textStyle" ref="text">
    </div>
    <div v-if="showMore" class="red pointer more" role="button" @click="open">
      <span class="more-text">
        {{moreText}}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
    moreText: String,
    disableDesktopMode: {
      type: Boolean,
      default: false
    },
    lines: {
      type: Number,
      default: 4
    },
    highView: {
      type: Boolean,
      default: false
    },
    pushDown: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      showMore: false
    }
  },
  methods: {
    open() {
      this.showMore = false;
      this.$refs.text.classList.add('open');
      if (this.pushDown) {
        this.$refs.text.style.marginBottom = "20px"
      }
    }
  },
  computed: {
    textStyle() {
      return "-webkit-line-clamp: " + this.lines + "; line-clamp: " + this.lines + ";" + ( (this.highView && (this.$isDesktop() || this.$isTablet())) ? "max-height: 9.4em;" : "max-height: 2.5em;") ;
    }
  },
  mounted() {
    if (!this.disableDesktopMode) {
      if (this.$isDesktop()) {
        this.open();
        return;
      }
    }
    this.showMore = this.$refs.text.scrollHeight > this.$refs.text.offsetHeight;
  }
}
</script>
<style scoped>
.text {
  overflow: hidden;
  text-overflow: clip;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  white-space: pre-wrap;
  max-height: 3.5em;
}
.more {
  text-align: left;
  position: relative;
  top: -0.5em; 
  padding-top: 3px;
}

.more-text {
  background-color: white;
  padding-right: 5px;
}

.open {
  -webkit-line-clamp: inherit !important; /* number of lines to show */
  line-clamp: inherit !important;
  max-height: inherit !important;
}
</style>